var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1386 10L20.0044 10.4558V23.6802L20.1386 23.8141L26.2771 20.1855L20.1386 10Z",
    fill: "#343434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1387 10L14 20.1855L20.1387 23.8141V17.3953V10Z",
    fill: "#8C8C8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1386 24.9763L20.063 25.0685V29.7792L20.1386 30L26.2809 21.3496L20.1386 24.9763Z",
    fill: "#3C3C3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1387 30V24.9763L14 21.3496L20.1387 30Z",
    fill: "#8C8C8C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1387 23.814L26.2772 20.1855L20.1387 17.3953V23.814Z",
    fill: "#141414"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20.1855L20.1387 23.814V17.3953L14 20.1855Z",
    fill: "#393939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.3cb0dadce4b3c59f7f681073e7631b5c.svg";
export { ForwardRef as ReactComponent };